
/******************************
 * Subscription Listing Page
 ******************************/

function getSubscriptionProducts(data){
    if(!data.plandata){
        return '';
    }
    if(!data.plandata.product.length){
        return '';
    }
    
    var html = '<ul>';
    data.plandata.product.forEach(function(product){
        var productUrl = '/products/' + product.handle;
        if(product.variant_id){
            productUrl += '?variant=' + product.variant_id;
        }
        html += `<li><a href="${productUrl}" target="_blank">${product.title}</a></li>`;
    })
    
    
    html += '</ul>';
    return html;
}
function subsListItem(data){
    var params = getAllParams();
    params.page = 'details';
    params.plan = data.subscription_id;
    var url = paramsToUrl(params);
    var html = `<div class="subCard">
        <div class="subBoxleft">
            <div class="SubBoxInner">
                <div class="iconBox">
                    <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M27.125 3.1H22.475V0.775C22.475 0.569457 22.3933 0.372333 22.248 0.226992C22.1027 0.0816517 21.9055 0 21.7 0C21.4945 0 21.2973 0.0816517 21.152 0.226992C21.0067 0.372333 20.925 0.569457 20.925 0.775V3.1H10.075V0.775C10.075 0.569457 9.99335 0.372333 9.84801 0.226992C9.70267 0.0816517 9.50554 0 9.3 0C9.09446 0 8.89733 0.0816517 8.75199 0.226992C8.60665 0.372333 8.525 0.569457 8.525 0.775V3.1H3.875C2.84766 3.10123 1.86276 3.50988 1.13632 4.23632C0.409883 4.96276 0.00123059 5.94766 0 6.975V27.125C0.00123059 28.1523 0.409883 29.1372 1.13632 29.8637C1.86276 30.5901 2.84766 30.9988 3.875 31H27.125C28.1525 30.9992 29.1376 30.5907 29.8641 29.8641C30.5907 29.1376 30.9992 28.1525 31 27.125V6.975C30.9992 5.94754 30.5907 4.96239 29.8641 4.23587C29.1376 3.50934 28.1525 3.10082 27.125 3.1ZM29.45 27.125C29.45 27.7416 29.205 28.333 28.769 28.769C28.333 29.205 27.7416 29.45 27.125 29.45H3.875C3.25837 29.45 2.667 29.205 2.23098 28.769C1.79495 28.333 1.55 27.7416 1.55 27.125V13.95H29.45V27.125ZM29.45 12.4H1.55V6.975C1.55 5.6916 2.5885 4.65 3.875 4.65H8.525V6.975C8.525 7.18054 8.60665 7.37767 8.75199 7.52301C8.89733 7.66835 9.09446 7.75 9.3 7.75C9.50554 7.75 9.70267 7.66835 9.84801 7.52301C9.99335 7.37767 10.075 7.18054 10.075 6.975V4.65H20.925V6.975C20.925 7.18054 21.0067 7.37767 21.152 7.52301C21.2973 7.66835 21.4945 7.75 21.7 7.75C21.9055 7.75 22.1027 7.66835 22.248 7.52301C22.3933 7.37767 22.475 7.18054 22.475 6.975V4.65H27.125C27.7416 4.65 28.333 4.89495 28.769 5.33098C29.205 5.767 29.45 6.35837 29.45 6.975V12.4Z" fill="#212B4F"/>
                    </svg>                
                </div>
                <div class="iconText">
                    <div class="subscribeHeading">Deliver</div>
                    <p>${data.shippment.label}</p>
                </div>
            </div>`;

        if(data.Status == "cancelled" || data.status == "cancelled"  || !data.Status || data.Status == 'pending'){
            
            html += `
            <div class="SubBoxInner">
                <div class="iconBox">
                    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8.4 20.7013L14 15.1013L19.6 20.7013L20.7013 19.6L15.1013 14L20.7013 8.4L19.6 7.29867L14 12.8987L8.4 7.29867L7.29867 8.4L12.8987 14L7.29867 19.6L8.4 20.7013ZM14.0047 28C12.0696 28 10.2496 27.6329 8.54467 26.8987C6.84082 26.1634 5.35837 25.1658 4.09733 23.9058C2.8363 22.6468 1.83815 21.1659 1.10289 19.4631C0.36763 17.7603 0 15.9408 0 14.0047C0 12.0696 0.367111 10.2496 1.10133 8.54467C1.83659 6.84082 2.83422 5.35837 4.09422 4.09733C5.35319 2.8363 6.83407 1.83815 8.53689 1.10289C10.2397 0.36763 12.0592 0 13.9953 0C15.9304 0 17.7504 0.367111 19.4553 1.10133C21.1592 1.83659 22.6416 2.83422 23.9027 4.09422C25.1637 5.35319 26.1619 6.83407 26.8971 8.53689C27.6324 10.2397 28 12.0592 28 13.9953C28 15.9304 27.6329 17.7504 26.8987 19.4553C26.1634 21.1592 25.1658 22.6416 23.9058 23.9027C22.6468 25.1637 21.1659 26.1619 19.4631 26.8971C17.7603 27.6324 15.9408 28 14.0047 28ZM14 26.4444C17.4741 26.4444 20.4167 25.2389 22.8278 22.8278C25.2389 20.4167 26.4444 17.4741 26.4444 14C26.4444 10.5259 25.2389 7.58333 22.8278 5.17222C20.4167 2.76111 17.4741 1.55556 14 1.55556C10.5259 1.55556 7.58333 2.76111 5.17222 5.17222C2.76111 7.58333 1.55556 10.5259 1.55556 14C1.55556 17.4741 2.76111 20.4167 5.17222 22.8278C7.58333 25.2389 10.5259 26.4444 14 26.4444Z" fill="#212B4F"/>
                    </svg>
                </div>
                <div class="iconText">
                    <div class="subscribeHeading">${!data.Status?'Hold on':(data.Status == 'pending'?'Pending on':'Cancelled on')}</div>
                    <p>${getTime(data.updated_at)}</p>
                </div>
            </div>`;
        }else{
          html += `
            <div class="SubBoxInner">
                <div class="iconBox">
                    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg"> <g clip-path="url(#clip0_25_11)"> <path d="M23.3051 17.5122C23.2594 16.9202 22.9336 16.2597 22.6182 15.6209C22.4661 15.3133 22.3091 14.995 22.1924 14.6999C21.9448 14.0719 21.4541 12.9878 20.9514 12.7876C20.7066 12.6899 20.4686 12.6934 20.2455 12.7998C20.076 12.8804 19.9365 13.0128 19.8252 13.1555V6.79849C19.8255 6.75924 19.8295 5.83431 19.2521 5.25017C18.9516 4.94615 18.5531 4.79199 18.0681 4.79199C17.3252 4.79199 16.4399 5.16774 16.4399 6.95728V11.3371C16.1655 10.9257 15.7173 10.5753 15.03 10.5753C13.744 10.5753 13.294 11.5512 13.1827 12.1518C12.9268 11.7767 12.509 11.4516 11.8731 11.4516C10.4832 11.4516 10.1909 12.8515 10.1909 13.1274V13.461C9.95293 13.1459 9.58253 12.8904 9.03443 12.8904C8.0831 12.8904 7.47113 13.5905 7.43758 14.7178C7.4201 15.3091 7.5036 23.6102 7.50824 23.9806L7.5243 24.1322C7.60387 24.8095 7.788 25.3833 7.8979 25.7262L7.95072 25.8932C8.05884 26.2461 8.0542 26.6154 8.0542 26.6222L8.05027 30.8215C8.05027 30.9196 8.12985 30.9999 8.22869 30.9999C8.32718 30.9999 8.40711 30.92 8.40711 30.8218L8.41139 26.6229C8.41139 26.6194 8.41139 26.6158 8.41104 26.6129C8.41139 26.5394 8.40675 26.1633 8.29221 25.7886L8.23797 25.617C8.12521 25.2652 7.95428 24.7335 7.87935 24.0926L7.864 23.9595C7.86329 23.8731 7.77694 15.3123 7.79442 14.7278C7.80762 14.2824 7.955 13.2469 9.03443 13.2469C10.0307 13.2469 10.1863 14.3245 10.1909 14.347V15.3248C10.1909 15.4232 10.2709 15.5032 10.3694 15.5032C10.4678 15.5032 10.5478 15.4232 10.5478 15.3248V13.1288C10.5481 13.1156 10.6909 11.8081 11.8731 11.8081C12.9486 11.8081 13.1466 12.9618 13.1523 12.9832V15.2388C13.1523 15.3372 13.2323 15.4172 13.3307 15.4172C13.4292 15.4172 13.5092 15.3372 13.5092 15.2388V12.4461C13.5092 12.4312 13.5745 10.9317 15.03 10.9317C16.2436 10.9317 16.4342 12.2624 16.4399 12.2959V15.4968C16.4399 15.5952 16.5198 15.6752 16.6183 15.6752C16.7168 15.6752 16.7967 15.5952 16.7967 15.4968V6.95728C16.7967 5.75724 17.2246 5.14883 18.0681 5.14883C18.4539 5.14883 18.7665 5.26694 18.9973 5.4996C19.4701 5.97633 19.4687 6.78635 19.4687 6.79635V18.0075C19.4687 18.0431 19.4755 18.0995 19.4898 18.1695C19.5201 18.34 19.5936 18.6216 19.766 18.8321C19.8762 18.993 20.0211 19.1365 20.2081 19.2186C20.2951 19.256 20.3972 19.22 20.4397 19.1343C20.4818 19.0487 20.4489 18.9449 20.3658 18.8988C20.3644 18.8981 20.222 18.8182 20.0486 18.6144C19.9326 18.4374 19.8666 18.2283 19.8395 18.1038C19.8295 18.0453 19.8259 18.0078 19.8259 18.0078V13.8988C19.8916 13.7094 20.0975 13.2651 20.3993 13.1216C20.531 13.0592 20.6684 13.0588 20.819 13.1191C21.0788 13.2226 21.497 13.9106 21.8602 14.8312C21.9823 15.1399 22.1425 15.4646 22.2977 15.7787C22.5982 16.3871 22.9086 17.0162 22.9493 17.5393C23.0845 19.2981 22.5482 21.0591 21.4395 22.499C20.8204 23.3029 20.0664 24.1079 19.3377 24.8866C18.502 25.7794 17.7131 26.6226 17.3309 27.2688C17.2395 27.4226 17.156 27.6806 17.1468 27.7095C17.1411 27.727 17.1386 27.7452 17.1386 27.7634V30.814C17.1386 30.9125 17.2185 30.9924 17.317 30.9924C17.4155 30.9924 17.4954 30.9125 17.4954 30.814V27.7919C17.5232 27.7088 17.5842 27.5407 17.6378 27.4508C18.0003 26.8374 18.7761 26.0085 19.5979 25.1303C20.3326 24.3456 21.0923 23.5334 21.7221 22.7159C22.8851 21.2069 23.4471 19.3588 23.3051 17.5122Z" fill="black" stroke="black" stroke-width="0.5"/> <path d="M15.0557 6.85035C15.1417 6.80182 15.1716 6.69298 15.1231 6.60698C14.8262 6.08136 14.6692 5.48437 14.6692 4.88025C14.6692 2.93727 16.25 1.35648 18.193 1.35648C20.136 1.35648 21.7167 2.93727 21.7167 4.88025C21.7167 5.65137 21.4687 6.3861 20.9988 7.00521C20.9392 7.08372 20.9545 7.19576 21.0334 7.25536C21.0655 7.27962 21.1033 7.29175 21.1412 7.29175C21.1947 7.29175 21.2482 7.26749 21.2832 7.2211C21.8002 6.53918 22.0736 5.72988 22.0736 4.8806C22.0736 2.74065 20.3326 1 18.193 1C16.053 1 14.3124 2.74065 14.3124 4.8806C14.3124 5.54611 14.4854 6.20376 14.8123 6.7829C14.8612 6.86819 14.9704 6.89816 15.0557 6.85035Z" fill="black" stroke="black" stroke-width="0.5"/> </g> <defs> <clipPath id="clip0_25_11"> <rect width="30" height="30" fill="white"/> </clipPath> </defs> </svg>
                </div>
                <div class="iconText">
                    <div class="subscribeHeading">Starts at</div>
                    <p>${getTime(data.createdAt)}</p>
                </div>
            </div>`;
          
        }
  
        
        html += `
            <div class="SubBoxInner">
                <div class="iconBox">
                    <svg width="32" height="26" viewBox="0 0 32 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M30.2713 7.76866L30.2652 7.67775C30.1065 5.29893 29.6704 3.5069 28.3353 2.17273C27.253 1.09394 25.8775 0.6085 24.1497 0.375984L30.2713 7.76866ZM30.2713 7.76866L30.3547 7.80519M30.2713 7.76866L30.3547 7.80519M30.3547 7.80519C31.1684 8.16134 31.7773 8.91387 31.8429 9.86213L31.8431 9.86405M30.3547 7.80519L31.8431 9.86405M31.8431 9.86405C31.8499 9.94747 31.85 10.0378 31.85 10.1281V15.8719C31.85 15.9619 31.8499 16.0532 31.8444 16.1364C31.7772 17.0848 31.1683 17.8388 30.3545 18.1964L30.2713 18.233M31.8431 9.86405L30.2713 18.233M30.2713 18.233L30.2652 18.3237M30.2713 18.233L30.2652 18.3237M30.2652 18.3237C30.1065 20.7011 29.6704 22.4931 28.3353 23.8273M30.2652 18.3237L28.3353 23.8273M28.3203 18.4214L28.3065 18.5841C28.1359 20.5888 27.7476 21.6852 26.9665 22.4633C26.3045 23.1241 25.4044 23.5093 23.8919 23.7121C22.3496 23.9188 20.321 23.9214 17.4869 23.9214H13.0218C10.1877 23.9214 8.16055 23.9188 6.61822 23.7121C5.10422 23.5093 4.2041 23.1241 3.54203 22.4632C2.87994 21.8023 2.49397 20.9037 2.29078 19.3937L2.43944 19.3737L2.29078 19.3937C2.08373 17.8541 2.08107 15.829 2.08107 13C2.08107 10.171 2.08373 8.14742 2.29078 6.60778C2.49397 5.09636 2.87992 4.19773 3.54203 3.53681C4.20408 2.87594 5.10419 2.49071 6.61672 2.2879L6.61675 2.2879C8.16055 2.08123 10.1877 2.07857 13.0218 2.07857H17.4869C20.3209 2.07857 22.3496 2.08123 23.8904 2.2879L28.3203 18.4214ZM28.3203 18.4214H28.157H25.2726C22.1513 18.4214 19.4973 16.0587 19.4973 13C19.4973 9.94124 22.1513 7.57857 25.2711 7.57857H28.1555H28.3189L28.305 7.41584C28.1344 5.41289 27.7476 4.31485 26.9665 3.5367M28.3203 18.4214L26.9665 3.5367M26.9665 3.5367C26.3045 2.87589 25.4044 2.4907 23.8905 2.2879L26.9665 3.5367ZM17.5717 0.15H12.9399C10.2004 0.15 8.04647 0.150308 6.36196 0.375974L17.5717 0.15ZM17.5717 0.15C20.3113 0.15 22.4667 0.150309 24.1497 0.375974L17.5717 0.15ZM28.3353 23.8273C27.253 24.9061 25.8775 25.3915 24.1497 25.624M28.3353 23.8273L24.1497 25.624M24.1497 25.624C22.4652 25.8497 20.3113 25.85 17.5717 25.85M24.1497 25.624L17.5717 25.85M17.5717 25.85H12.9399M17.5717 25.85H12.9399M0.376371 6.3507C0.150311 8.03065 0.15 10.1821 0.15 12.9168V13.0832C0.15 15.8179 0.15031 17.9679 0.376383 19.6494C0.609309 21.374 1.0956 22.747 2.17637 23.8273C3.2586 24.9061 4.63413 25.3915 6.36189 25.624L0.376371 6.3507ZM0.376371 6.3507C0.609287 4.62609 1.09556 3.25308 2.17629 2.17279M0.376371 6.3507L2.17629 2.17279M2.17629 2.17279C3.25853 1.09396 4.63408 0.608508 6.36187 0.375986L2.17629 2.17279ZM12.9399 25.85C10.2003 25.85 8.04498 25.8497 6.36196 25.624L12.9399 25.85ZM29.2887 9.50728L29.2887 9.50714H29.2822H25.2726C23.0801 9.50714 21.4299 11.1381 21.4299 13C21.4299 14.8618 23.0801 16.4929 25.2711 16.4929H29.3165V16.4932L29.3259 16.4926C29.7037 16.4688 29.8986 16.2067 29.9154 16.0047L29.916 16.0048V15.9922V10.0078H29.9165L29.9154 9.99529C29.8986 9.79332 29.7035 9.53088 29.3252 9.50888L29.3252 9.50887L29.323 9.50877L29.2887 9.50728ZM6.10349 7.05714C6.10349 6.80149 6.20523 6.55624 6.38641 6.37538C6.5676 6.19452 6.81341 6.09286 7.06977 6.09286H13.0233C13.2796 6.09286 13.5254 6.19452 13.7066 6.37538C13.8878 6.55624 13.9895 6.80149 13.9895 7.05714C13.9895 7.3128 13.8878 7.55804 13.7066 7.7389C13.5254 7.91977 13.2796 8.02143 13.0233 8.02143H7.06977C6.81341 8.02143 6.5676 7.91977 6.38641 7.7389C6.20523 7.55804 6.10349 7.3128 6.10349 7.05714Z" fill="#222222" stroke="white" stroke-width="0.3"/>
                    </svg>
                </div>
                <div class="iconText">
                    <div class="subscribeHeading">Billing Amount</div>
                    <p>${subsFormatCurrency(data.product.billing_price)}</p>
                </div>
            </div>
        </div>
        <div class="subBoxright">
            <div class="subRight">
                <div class="subrightTop">
                    <div class="prdId">Subscription ID: ${data.subscription_id}</div>
                    <div class="subscribeHeading">Products</div>
                    <!-- Product Data Here -->
                    ${subsListProducts(data.plandata?data.plandata.product:data.product,data.shippment)}
                </div>
                <div class="subrightbottom">`;
                if(params.plan != null ){
                html += `
                
                    <a href="${window.location.pathname}?${url}" target="_blank">
                        <svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M8 7C8 7.53043 8.21071 8.03914 8.58579 8.41421C8.96086 8.78929 9.46957 9 10 9C10.5304 9 11.0391 8.78929 11.4142 8.41421C11.7893 8.03914 12 7.53043 12 7C12 6.46957 11.7893 5.96086 11.4142 5.58579C11.0391 5.21071 10.5304 5 10 5C9.46957 5 8.96086 5.21071 8.58579 5.58579C8.21071 5.96086 8 6.46957 8 7Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M19 7C16.6 11 13.6 13 10 13C6.4 13 3.4 11 1 7C3.4 3 6.4 1 10 1C13.6 1 16.6 3 19 7Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        View Subscription
                    </a>`;
                }
        html += `                    
                </div>
            </div>
        </div>
    </div>`;
    return html;
}

function subsListProducts(data,shippment){
    var html = '';
        var productUrl = '/products/' + data.handle;
        if(data.variant_id){
            productUrl += '?variant=' + data.variant_id;
        }
        html += `
        <div class="tableBar table-responsive">
            <div class="productImg">
                <a href="${productUrl}">
                    <img src="${data.image}" alt="${data.title}" width="100">
                </a>
            </div>
            <table>
                <tr>
                    <th><a href="${productUrl}">${data.title}</a></th>
                    <th>Qty</th>
                </tr>
                <tr>
                    <td class="prdName">${shippment.label}</td>
                    <td class="text-center">${data.quantity}</td>
                </tr>
            </table>
        </div>
        `;
    return html;
}






/******************************
 * Paginations
 ******************************/
function subsChangePage(element){
    var target = element.getAttribute('data-target');
    var parent = document.querySelector(target),
    offset = element.getAttribute('data-offset');
    
    start = offset - perPage;
    var page = Math.ceil(offset / perPage);
    var params = getAllParams();
    
    if(target == '#ACTIVE'){
        var obj = subPaginationPage(activeElements,start,offset,parent);
        var pageWrapper = parent.querySelector('.subscriptionListActive')
        var navWrapper = parent.querySelector('#subsPaginationActive');
        pageWrapper.style.opacity = '0.2'
        setTimeout(function(){
            pageWrapper.innerHTML = obj.page;
            navWrapper.innerHTML = obj.nav;
            pageWrapper.style.opacity = '1';
            params.s = 'active';
            params.o = offset;
            var url = paramsToUrl(params);
            url = `${window.location.pathname}?${url}`;
            subsPushURL(url);
            window.scrollTo({ top: 120, behavior: 'smooth' });
        },500)
        //subsPaginationNav(total,start,offset,parent)
    }
    if(target == '#CANCELLED'){
        var obj = subPaginationPage(cancelElements,start,offset,parent);
        var pageWrapper = parent.querySelector('.subscriptionListCancel')
        var navWrapper = parent.querySelector('#subsPaginationCancel');
        pageWrapper.style.opacity = '0.2'
        setTimeout(function(){
            pageWrapper.innerHTML = obj.page;
            navWrapper.innerHTML = obj.nav;
            pageWrapper.style.opacity = '1';
            params.s = 'cancel';
            params.o = offset;
            var url = paramsToUrl(params);
            url = `${window.location.pathname}?${url}`;
            subsPushURL(url);
            window.scrollTo({ top: 120, behavior: 'smooth' });
        },500)
        //subsPaginationNav(total,start,offset,parent)
    }
}


function subsPaginationInit(){
    document.querySelectorAll('#ACTIVE').forEach(function(parent){
        parent.querySelectorAll('.subCard').forEach(function(element){
            element.remove();
            activeElements.push(element)
        });
        var obj = subPaginationPage(activeElements,0,perPage,parent);
        if(getParam('s') == 'active'){
            //obj = subPaginationPage(activeElements,getParam('o'),offset + perPage,parent);
        }
        
        parent.querySelector('.subscriptionListActive').innerHTML = obj.page?obj.page:'<br/>No Active Subscriptions';
        parent.querySelector('#subsPaginationActive').innerHTML = obj.nav;
    });
    document.querySelectorAll('#CANCELLED').forEach(function(parent){
        parent.querySelectorAll('.subCard').forEach(function(element){
            element.remove();
            cancelElements.push(element)
        });
        var obj = subPaginationPage(cancelElements,0,perPage,parent);
        
        if(getParam('s') == 'cancel'){
            //obj = subPaginationPage(cancelElements,getParam('o'),offset + perPage,parent);
        }
        
        parent.querySelector('.subscriptionListCancel').innerHTML = obj.page?obj.page:'<br/>No Cancelled Subscriptions';
        parent.querySelector('#subsPaginationCancel').innerHTML = obj.nav;
    });
    
}
function subPaginationPage(elements,start,offset,parent){
    var html = '';
    elements.slice(start,offset).forEach(function(el){
        html += el.outerHTML;
    })
    
    return {
        'page' : html,
        'nav' : subsPaginationNav(elements.length,start,offset,parent)
    };
}
function subsPaginationNav(total,start,offset,parent){
    var target = '#'+parent.getAttribute('id');
    if(offset < perPage){
        page = 1;
    }else{
        var page = ((offset * 1 ) ) / perPage ;
    }
    page = Math.ceil(page);
    totalPage = Math.ceil(total / perPage);
    
    if(totalPage == 1 ){
        return '';
    }
    var navHTML = '<ul>';
    
    for(i=1;i<=totalPage;i++){
        var cls = '';
        if(i == page){
            cls = 'active'
        }
        navHTML += `<li><button type="button" data-offset="${i*perPage}" class="subsPageCount ${cls}" data-target="${target}" onclick="subsChangePage(this)" data-page="${i}">${i}</a></li>`
    }
    return navHTML;
}


/******************************
 * Subscription Details Page
 ******************************/
function getSubscriptionOrders(data){
  
    if(!data.length ){
        return 'No Orders';
    }
    var html = '';
    data.forEach(function(order){
        html += `
        <div class="subRight">
            <div class="subMainDetailBlock">
                <div class="headingFlex">
                    <div class="prdId">Order: <a target="_blank" href="/account/orders/${order.token}">${order.name}</a> | ${getTime(order.created_at)}</div>
                    <div class="cancelAlert">${order.cancelled_at?'Canceled':''}</div>
                </div>
                <div class="customDetailInfo">
                    <div class="detailblock">
                        <div class="personalDetail">
                            <div class="subscribeHeading"> Contact Information</div>
                            <a href="mailto:${order.contact_email}">${order.contact_email}</a>
                        </div>
                        <div class="personalDetail">
                            <div class="subscribeHeading"> Shipping Address</div>
                            <div class="address">
                                ${subsFormatAddress(order.shipping_address)}
                            </div>
                        </div>
                    </div>
                    <div class="detailblock">
                        <div class="personalDetail">
                            <div class="subscribeHeading"> Order Total</div>
                            <p>${subsFormatCurrency(order.current_total_price)}</p>
                        </div>
                        <div class="personalDetail">
                            <div class="subscribeHeading"> Billing Address</div>
                            <div class="address">
                                ${subsFormatAddress(order.shipping_address)}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
    });
    return html;
}







/******************************
 * Main Functions 
 ******************************/
function initSubscription(){        
    var pageType = getParam('page');
    switch(pageType){
        case 'details':
            getSubscriptionDetail();
        break;
        default:
            getSubscriptions();
    }
}
function subsFormatCurrency(amount){
    if(!amount) return '';
    return '₹' + amount;
}
function getTime(time){
    var months = ['Jan','Feb','March','April','May','June','July','Aug','Sep','Oct','Nov','Dec']
    var time = new Date(time);
  
    return months[time.getMonth()]+' '+time.getDate()+', '+time.getFullYear();
}
function paramsToUrl(paramsObject) {
    const queryString = Object.keys(paramsObject)
      .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(paramsObject[key]))
      .join('&');
    return queryString;
}
function getAllParams(){
    const url = window.location.href;
    const urlObject = new URL(url);
    const params = urlObject.searchParams;
    const paramsObject = {};
    params.forEach((value, key) => {
      paramsObject[key] = value;
    });
    return paramsObject;
}
function timestampToHumanReadable(timestampSeconds) {
    return new Date(timestampSeconds * 1000).toLocaleString();
}
function subsAlert(msg,type,element){
    var html = '';
    switch(type){
        case 'error':
            html = `<div class="error">${msg}</div>`;
        break;
        case 'success':
            html = `<div class="success">${msg}</div>`;
        break;
    }
    element.innerHTML = html;
}
function getParam(param){
    const queryString = window.location.search;
    const searchParams = new URLSearchParams(queryString);
    const paramValue = searchParams.get(param);
    return paramValue;
}
function serverRequest(endpoint,method,body,callback,errorCallback){
    body.timestamp = timestamp;
    fetch("/apps/subscription/" + endpoint, {
        method: method?method:'GET',
        headers: {
          "Content-Type": "application/json",
          "access-token": apiToken
        },
        body: JSON.stringify(body),
        redirect: "follow"
    })
    .then((response) => {
      if(response.status == 200){
        return response.json();
      }
      return [];
    })
    .then(function(result){
        if(callback){
            callback(result)
        }
    })
    .catch(function(error){
        if(errorCallback){
          errorCallback(error);
          return ;
        }
        subsAlert('Something went wrong, please try again later','error',subsWrapper);
        console.log(error)
    });
}
function subsFormatAddress(address){
    if(!address){
        return '';
    }
    return [
        address.company?address.company +',<br>':'',
        address.first_name?address.first_name:'',
        address.last_name?' '+address.last_name + ',<br/>':'',
        address.address1?address.address1 + ',<br/>':'',
        address.address2?address.address2 + ',<br/>':'',
        address.city?address.city+', ':'',
        address.province?address.province+', ':'',
        address.country?address.country+ ', ':'',
        address.zip?' - ' + address.zip:''
    ].join('');
}
$(document).on('click','.subscriptionTabs li span',function (e) {
    var position = $(this).position();
    scroll = $('.tabscatgory').scrollLeft();
    $('.tabscatgory').animate({
        'scrollLeft': scroll + position.left - 30
    }, 200);
});

$(document).on('click','.subscriptionTabs li span',function (e) {
    
    var target = $(this).attr('data-rel');
    $('.tab-menu-list li span').removeClass('active');
      $(this).addClass('active');
      $("#"+target).fadeIn('slow').siblings(".tab-output-box").hide();
      return false;
});
function subsPushURL(url) {
    return ;
    window.history.pushState({}, '', url);
}